import { simpleFormatter } from '../formatters';
import { LogEntry } from '../log-entry';
import { LogLevel } from '../log-level';
import { LogFormatter, LogPublisher } from '../log-publisher';

export class ConsoleLogger implements LogPublisher {
  private static callbacks: Map<LogLevel, any> = new Map([
    [LogLevel.EMERG, console.error],
    [LogLevel.ALERT, console.error],
    [LogLevel.CRIT, console.error],
    [LogLevel.ERROR, console.error],
    [LogLevel.WARN, console.warn],
    [LogLevel.NOTICE, console.info], // tslint:disable-line no-console
    [LogLevel.INFO, console.info], // tslint:disable-line no-console
    [LogLevel.DEBUG, console.log]
  ]);

  constructor(readonly format: LogFormatter = simpleFormatter) {}

  log(record: LogEntry): void {
    const callback = ConsoleLogger.callbacks.get(record.level);
    callback(this.format(record));
  }
}
